// extracted by mini-css-extract-plugin
var _1 = "P1ldtosa";
var _2 = "P1ldtosa";
var _3 = "ifJ0VFiz";
var _4 = "ifJ0VFiz";
export { _1 as "anchored-popover", _2 as "anchoredPopover", _3 as "popover-button", _4 as "popoverButton" }
